export enum VOSA_DOCUMENT_TYPE {
  INCOMING = 'incoming',
  OUTGOING = 'outgoing',
  ELECTRONIC_ISSUANCE = 'electronic-issuance',
}

export enum DOCUMENT_MANAGEMENT_TYPE {
  INTERNAL = 'internal',
  USER_GROUP = 'user-group',
}

export enum VOSA_INCOMING_DOCUMENT_STATUS {
  APPROVED = 'APPROVED',
  CANCELLED = 'CANCELLED',
  PROCESSING = 'PROCESSING',
}

export enum ELECTRONIC_ISSUANCE_DOCUMENT_STATUS {
  UNPROCESSED = 'UNPROCESSED',
  LEADER_APPROVED = 'LEADER_APPROVED',
  NUMBER_ASSIGNED = 'NUMBER_ASSIGNED',
  PUBLISHED = 'PUBLISHED',
}

export type TVOSAIncomingDocument = {
  id: string;
  arrivalNumber: number;
  documentCode: string;
  arrivalDate: string;
  documentDate?: string | null;
  status: VOSA_INCOMING_DOCUMENT_STATUS;
  summary: string;
  issuingAuthority: string;
  assignedLeader?: string | null;
};

export type TVOSAElectronicIssuanceDocument = {
  id: string;
  title: string;
  submitter: string;
  signer?: string;
  status: ELECTRONIC_ISSUANCE_DOCUMENT_STATUS;
  submittedDate: string;
};
